export default {
  title: 'Email Automation',
  description:
    'Customers will receive professional email on your behalf designed to convert new people or retain those who are already a rewards member. Select which emails you want to send to customers.',
  invited: 'Customers invited',
  newMembers: 'New members',
  conversionRate: 'Conversion rate',
  tagText: 'Member Acquisition',
  email: {
    title: 'Reward & invite non-member customers after purchase',
    description:
      'Encouraging your Loyalty Rewards Program customers to claim their rewards after a purchase.'
  },
  detail: {
    title: 'Reward & Invite non-member customers after purchase',
    description:
      "Invite your non-member customers to claim their rewards by joining your program. Reminder: you've previously set the",
    descriptionLink: 'rewards rate here.',
    status: 'Email flow status',
    howItWorks: {
      title: 'How it works?',
      pointOne: 'First, make sure you installed the widget on your website.',
      pointTwo:
        'This automation will send an email to all customers that purchased in your store and are NOT a part of your Loyalty Rewards Program.',
      pointThree:
        'One hour after a non-member customer purchases, Twism will automatically send them an email on your behalf.'
    },
    flow: 'Email sending flow'
  },
  empty: {
    title: 'We just made it easier to get in touch with customers',
    description:
      'Use pre-written, customizable and automated emails to send to current customers or future members.',
    btn: 'Explore Email Automation',
    btnUpgrade: 'Upgrade & Explore Email Automation',
    learnMore: 'Learn more about Email Automation'
  },
  modals: {
    disable: {
      title: 'Inactivate “{nameEmail}” email',
      description:
        'By deactivating this campaign, customers who buy on your website <b>from {date}</b> onwards will not receive this email. Do you want to stop this campaign?'
    },
    enable: {
      title: 'Activate “{nameEmail}” email',
      description:
        'You activated the <b>“{nameEmail}”</b> email that will send an email to <b>every non-member customer who made a purchase on your website, but haven’t collected their rewards.</b>',
      disclaimer:
        'The goal is to promote your business and have new customers sign up for your Loyalty Rewards Program.'
    },
    btnPrimary: 'Confirm',
    btnSecondary: 'Cancel'
  }
};
